import PAText from "component/design-system/typography/PAText/PAText";
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import styles from "./trusted-shop.module.scss";

const Column4 = dynamic(() => import(/* webpackChunkName: "footer-column4" */ "./Column4"), {
  loading: () => <LoaderSkeleton height={60} />,
});

function CustomerPaymentOptions({ className }: { className?: string }) {
  const { t } = useTranslation("common");

  return (
    <>
      <PAText
        component="p"
        className={`${styles.trusted_shops_title} ${className}`}
      >
        {t("We Accept")}
      </PAText>
      <Column4 bnplClass="hidden-xs" />
    </>
  );
}

export default CustomerPaymentOptions;
